.successIcon {
  border-radius: 50%;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.reviewButton {
  flex-shrink: 0;
}
